module.exports = __webpack_public_path__ + "static/solution-ampol-e68cc7abf20e66dd3457ffca83cd07de.png";